import React from 'react';
import Isvg from 'react-inlinesvg';

import Confirm from 'components/Confirm';
import Message from 'components/Message';
import { ICONS } from 'constants/icons';

import { resetModalMessages as messages } from './ScheduleIncrements.messages';

const ResetScheduleIncrementsModal = () => (
  <Confirm
    title={
      <div className="flex">
        <Isvg src={ICONS.infoYellow} className="mr-" />
        <Message message={messages.title} />
      </div>
    }
    cancelNode={<Message message={messages.cancel} />}
    acceptNode={<Message message={messages.accept} />}>
    <Message message={messages.body} />
  </Confirm>
);

export default ResetScheduleIncrementsModal;
